import clsx from 'clsx';
import { processTitle } from '../../utils/processTitle';

export interface CategoryHeroProps {
  image?: React.ReactNode;
  title: string;
  subTitle?: string;
  description?: React.ReactNode;
}

export function CategoryHero({
  image,
  title,
  subTitle,
  description,
}: CategoryHeroProps) {
  return (
    <div
      className={clsx({
        'aspect-[21/9] relative overflow-hidden rounded-lg overlay-after':
          image,
      })}
    >
      {image && (
        <figure
          className={clsx({
            'w-full h-full overflow-hidden [&_img]:absolute [&_img]:inset-0 [&_img]:h-full [&_img]:w-full [&_img]:rounded [&_img]:object-cover':
              image,
          })}
        >
          {image || <div className="absolute w-full h-full bg-grey-base" />}
        </figure>
      )}

      <div
        className={clsx('text-center', {
          'text-neutral-0 absolute bottom-8 w-full z-10': image,
        })}
      >
        <h1 className="mb-2 hd-2xl lg:hd-3xl">{processTitle(title)}</h1>
        {subTitle && <p className="leading-6">{subTitle}</p>}
        {description && <div className="leading-6">{description}</div>}
      </div>
    </div>
  );
}

export default CategoryHero;
